
import { useState } from 'react'

var showRequestDemo = false

export default {
    showRequestDemo: showRequestDemo
}